/* eslint-disable import/prefer-default-export */

const HTTP_REGEXP = /^https?:\/\//;
const PROTOCOL_REGEXP = /^[a-z]+:/;

export const isAbsolute = (url: string): boolean => HTTP_REGEXP.test(url);

export const isInternal = (url: string, origin: string | null): boolean => {
    const isAbsoluteLink = isAbsolute(url);
    const isAnotherProtocolLink = !isAbsoluteLink && PROTOCOL_REGEXP.test(url);
    const isRelativeLink = !isAbsoluteLink && !isAnotherProtocolLink;
    const isTheSameOriginLink = !!origin && url.startsWith(origin);
    return isRelativeLink || isTheSameOriginLink;
};
